import { render } from "./allorderlist.vue?vue&type=template&id=11051e38"
import script from "./allorderlist.vue?vue&type=script&lang=js"
export * from "./allorderlist.vue?vue&type=script&lang=js"

import "./allorderlist.vue?vue&type=style&index=0&id=11051e38&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__